/** 复制邀请链接分享 */

import { ActivityInfoData } from '@hooks/useActivityInfo';
import { Modal, Button, message } from '@tencent/tea-component';
import GenerateQrcode from '@tencent/tpm-meeting-active/lib/GenerateQrcode';
import beaconReport from '@utils/beacon';
import { downloadBlob } from '@utils/download-file';
import { getBetweenDate } from '@utils/parse-date';
import copyToClipboard from 'copy-to-clipboard';
import { FC, ReactElement, useMemo, useRef } from 'react';

import logo from '@assets/imgs/logo-color.svg';
import './index.scss';

export interface SecondaryDialogProps {
  visible: boolean;
  children: React.ReactElement;
  title: string;
  className?: string;
  buttons?: ({ txt: string; type?: 'primary' | 'weak'; onClick(): void } | ReactElement)[];
  destroyOnClose?: boolean;
  onClose?(): void;
  onBack?(): void;
}

const isReactElement = (data: any): data is ReactElement => typeof data.txt === 'undefined';

/** 二级弹窗 */
export const SecondaryDialog: FC<SecondaryDialogProps> = ({
  visible,
  title,
  className,
  buttons,
  destroyOnClose,
  onClose,
  onBack,
  children,
}) => (
  <Modal
    destroyOnClose={destroyOnClose}
    visible={visible}
    onClose={onClose}
    className={`secondary-dialog ${className || ''}`}
    caption={
      <div className="secondary-dialog-title">
        {onBack ? <i className="iconfont icon-arrow-left" onClick={onBack} /> : null}
        <span className="secondary-dialog-title-txt">{title}</span>
      </div>
    }
  >
    {children}
    <Modal.Footer>
      <div className="secondary-dialog-footer">
        {buttons?.map((btn, i) =>
          isReactElement(btn) ? (
            btn
          ) : (
            <Button type={btn.type} key={i} onClick={btn.onClick}>
              {btn.txt}
            </Button>
          ),
        )}
      </div>
    </Modal.Footer>
  </Modal>
);

export interface SecondDialogProps {
  event?: ActivityInfoData;
  userName?: string;
  visible: boolean;
  registrationUrl?: string;
  onClose(): void;
  onBack?(): void;
}

export const CopyLinkDialog: FC<SecondDialogProps> = ({
  event,
  userName,
  visible,
  onClose,
  onBack,
  registrationUrl = '',
}) => {
  console.log('event', registrationUrl);
  const txtRef = useRef<HTMLDivElement>(null);
  const buttons = useMemo(
    () =>
      [
        {
          txt: '复制邀请链接',
          type: 'primary',
          onClick() {
            beaconReport('e#event_share_popup#copy_link#click');
            copyToClipboard(txtRef.current!.innerText);
            message.success({ content: '复制成功' });
          },
        },
      ] as SecondaryDialogProps['buttons'],
    [],
  );

  return (
    <SecondaryDialog
      className="publish-share-text"
      title="复制邀请链接分享活动"
      buttons={buttons}
      visible={visible}
      onClose={onClose}
      onBack={onBack}
    >
      <div className="publish-share-text-content">
        <div className="share-content" ref={txtRef}>
          邀请您参加{userName}主办的活动，请点击下方链接查看详情。
          <br />
          <br />
          活动主题：{(event as any)?.meeting_title || event?.title || ''}
          <br />
          活动时间：{getBetweenDate(event?.start_time, event?.end_time)}
          <br />
          <br />
          点击链接查看详情：
          <br />
          <a href={registrationUrl}>{registrationUrl}</a>
        </div>
      </div>
    </SecondaryDialog>
  );
};

export const QrCodeDialog: FC<SecondDialogProps> = ({ event, visible, registrationUrl = '', onBack, onClose }) => {
  const canvasRef = useRef<HTMLDivElement>(null);
  const buttons = useMemo(
    () =>
      [
        {
          txt: '下载到电脑',
          type: 'primary',
          onClick() {
            const canvasEl = canvasRef.current!.querySelector('canvas');
            canvasEl!.toBlob((blob) => {
              downloadBlob(blob!, event?.title || '分享图');
            });
          },
        },
      ] as SecondaryDialogProps['buttons'],
    [event?.title],
  );

  return (
    <SecondaryDialog
      className="publish-share-qrcode"
      title="下载二维码分享活动"
      buttons={buttons}
      visible={visible}
      onClose={onClose}
      onBack={onBack}
    >
      <div className="publish-share-qrcode-content">
        <div className="qrcode" ref={canvasRef}>
          <GenerateQrcode
            link={registrationUrl}
            size={168}
            imageSettings={{
              src: logo,
              width: 30,
              height: 30,
              excavate: true,
            }}
          />
        </div>
      </div>
    </SecondaryDialog>
  );
};
